module.exports = __webpack_public_path__ + "static/media/b-social-instagram.af8186d9.png";